<template>
  <div id="chat">
    <div class="comment">
      <GiftHistory ref="giftHistory"/>
      <div class="comment__display" id="comment__scroll">
        <div
          class="comment__parts"
          v-for="(comment, index) in comments"
          :key="index"
        >
          <div class="media">
            <figure class="media-left">
              <div class="image">
                <img :src="findImage(comment.photoURL)"/>
              </div>
            </figure>
            <div v-if="comment.type == 'comment'" class="media-content">
              <div class="content">
                <p>
                  <strong>{{ comment.nickname }}</strong>
                  <br />
                  {{ comment.message }}
                  <br />
                </p>
              </div>
            </div>
            <div v-if="comment.type == 'enter'" class="media-content">
              <div class="enter-content">
                <p>{{ comment.nickname }} さんが来店しました</p>
              </div>
            </div>
            <div
              v-if="comment.type == 'gift'"
              class="media-content gift-content"
            >
              <figure class="gift-icon-container">
                <img :src="comment.iconURL" class="gift-icon" />
              </figure>
              <div class="content">
                <strong>{{ comment.nickname }}</strong>
                <br />
                <p class="gift-message">
                  "{{ comment.giftNameJP }}"が届きました！
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="comment__input" v-if="!isCast">
        <div class="comment__input__left">
          <b-image class="icon" :src="params.myPhotoURL" alt="" :rounded="true" ratio="400by255"/>
        </div>
        <div class="comment__input__form">
          <input
            placeholder="コメントを入力"
            v-model="comment"
            class="comment_box"
            @keydown.native.enter="onClickComment"
            :disabled="params.commentDisabled"
          />
        </div>
        <div class="comment__input__button">
          <p class="control">
          <b-button
            @click="onClickComment"
            rounded
            expanded
            :disabled="params.commentDisabled"
            ><span>送信</span></b-button>
          </p>
        </div>
      </div>
    </div>
    <div class="giftviewer" v-if="isCast">
      <div class="giftviewer__content">
        <div class="giftviewer__content__item" v-for="gift in viwerGifts" :key="gift.id">
          <img class="icon" :src="gift.iconURL"/>
          <p class="text">{{gift.count}}個</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as liveServices from '@/services/liveServices';
import GiftHistory from '@/components/GiftHistory';
import moment from 'moment';
import * as validation from '@/utils/validation';

export default {
  name: 'LiveStreaming',
  components: {
    GiftHistory
  },
  props: {
    params: {
      type: Object,
      default() {
        return {
          liveId: '',
          myPhotoURL: null,
          isRecentLive: false,
          commentDisabled: false
        };
      }
    },
    isCast: { type: Boolean },
    onClick: null
  },
  computed: {
    defaultPhotoURL() {
      return 'https://firebasestorage.googleapis.com/v0/b/pandora-988f8.appspot.com/o/all%2Fdefault-user-icon.png?alt=media&token=4a1a4307-1990-4c99-a944-9b8d289e1a50';
    }
  },
  data() {
    return {
      comment: '',
      comments: [],
      sendedGifts: [],
      viwerGifts: {},
      commentRefObj: {},
      timerID: null,
      waiting: false
    };
  },
  watch: {
    comment: function() {
      this.comment = validation.charaLimit(this.comment, 50);
    }
  },
  methods: {
    async readComment() {
      this.comments = [];
      this.commentRefObj = await liveServices.getLiveCommentRefObj(
        this.params.liveId
      );

      this.commentRefObj
        .orderByChild('timestamp')
        .limitToLast(100)
        .on('child_added', (snap) => {
          this.reloadComment(snap);
        });

      if (this.timerID) clearInterval(this.timerID);
      this.createSendedGifts();
      this.timerID = setInterval(() => {
        this.createSendedGifts();
      }, 1000);

      return this.commentRefObj;
    },
    reloadComment(snap) {
      for (var comment of this.comments) {
        if (JSON.stringify(comment) === JSON.stringify(snap.val())) {
          return;
        }
      }
      this.comments.push(snap.val());
      if (this.comments.length > 100) this.comments.splice(0, 1);
      this.scrollToBottom();
    },
    createSendedGifts() {
      var sendedGifts = [];

      this.comments.forEach(item => {
        if (item.type == "gift"
          && item.period
          && moment().unix() <= item.period) {
          sendedGifts.unshift(item);
        }
      });

      if (this.isCast) this.createViwerGifts();
      this.sendedGifts = this.sortSendedGifts(sendedGifts);
      if (this.$refs.giftHistory) this.$refs.giftHistory.setGifts(this.sendedGifts);
      this.$emit('gifts', sendedGifts);
    },
    createViwerGifts() {
      var sendedGifts = [];
      this.commentRefObj
        .on('child_added', (snap) => {
          let item = snap.val();
          if (item.type == "gift") {
            sendedGifts.push(item);
          }
        });

      let list = {};
      sendedGifts.forEach(item => {
        if (!list[item.giftId]) {
          list[item.giftId] = {
            id: item.giftId,
            iconURL: item.iconURL,
            count: 1
          }
        } else {
          list[item.giftId].count = list[item.giftId].count + 1;
        }
      });
      this.viwerGifts = list;
    },
    sortSendedGifts(sendedGifts) {
      if (!sendedGifts) {
        return [];
      }

      let newSendedGifts = sendedGifts;
      newSendedGifts.sort((itemA, itemB) => {
        if (itemA.isPaid != itemB.isPaid) {
          return itemA.isPaid < itemB.isPaid ? 1 : -1;
        }
        if (itemA.price != itemB.price) {
          return itemA.price < itemB.price ? 1 : -1;
        }
        if (itemA.timestamp != itemB.timestamp) {
          return itemA.timestamp < itemB.timestamp ? 1 : -1;
        }
        return 0;
      });

      if (newSendedGifts.length > 10) newSendedGifts = newSendedGifts.slice(0, 10);
      return newSendedGifts;
    },
    async onClickComment() {
      if (this.comment == '') return;

      let validateResult = await this.validate();
      if (!validateResult) {
        return;
      }

/*
      this.waiting = true;
      setTimeout(() => {
        this.waiting = false;
      }, 2000)
*/
      const payload = {
        userId: this.$store.state.auth.uid,
        nickname: this.$store.state.user.nickname,
        photoURL: this.$store.state.user.photoURL,
        message: this.comment,
        type: 'comment',
        timestamp: moment().unix()
      };
      this.comment = '';
      let newMessageRef = this.commentRefObj.push();
      newMessageRef.set(payload);
      this.scrollToBottom();
    },
    async enterUser() {
      const payload = {
        userId: this.$store.state.auth.uid,
        nickname: this.$store.state.user.nickname,
        photoURL: this.$store.state.user.photoURL,
        type: 'enter',
        timestamp: moment().unix()
      };
      let commentRefObj = await liveServices.getLiveCommentRefObj(
        this.params.liveId
      );
      commentRefObj.push(payload);
    },
    scrollToBottom() {
      setTimeout(() => {
        var area = document.getElementById('comment__scroll');
        area.scrollTop = area.scrollHeight;
      }, 500);
    },
    validate() {
      let errorMessage = this.check();

      if (errorMessage) {
        this.$buefy.toast.open({
          duration: 3000,
          message: errorMessage,
          type: 'is-danger'
        });
        return false;
      }

      return true;
    },
    check() {
      if (!validation.checkNGWord(this.comment)) {
        return "不適切な表現が含まれています。";
      }

      return null;
    },
    findImage(img) {
      return img ? img : this.defaultPhotoURL;
    },
  },
  beforeDestroy() {
    if (this.timerID) {
      clearInterval(this.timerID);
      this.timerID = null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/chat.scss';
</style>
